import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logofull.PNG';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="bg-dark border-b border-gray-800 fixed w-full z-50">
      <div className="container mx-auto px-4 py-6 flex justify-between items-center">
        {/* Left side - Burger menu */}
        <div className="w-1/3 flex justify-start">
          <button 
            className="text-light hover:text-primary transition-colors"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        
        {/* Center - Logo */}
        <div className="w-1/3 flex justify-center">
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Kala Hats" className="h-20 w-auto" />
          </Link>
        </div>
        
        {/* Right side - empty */}
        <div className="w-1/3 flex justify-end">
          {/* Empty space on the right */}
        </div>
      </div>

      {/* Slide-in Menu */}
      <div 
        className={`fixed top-0 left-0 h-full bg-dark w-64 shadow-lg transform transition-transform duration-300 ease-in-out z-50 ${
          menuOpen ? 'translate-x-0' : 'translate-x-[-100%]'
        }`}
      >
        <div className="flex justify-end p-4">
          <button 
            className="text-light hover:text-primary transition-colors"
            onClick={toggleMenu}
            aria-label="Close menu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <nav className="px-4 flex flex-col space-y-4">
          <Link 
            to="/" 
            className="text-light hover:text-primary transition-colors py-2 border-b border-gray-800"
            onClick={toggleMenu}
          >
            Home
          </Link>
          <Link 
            to="/products" 
            className="text-light hover:text-primary transition-colors py-2 border-b border-gray-800"
            onClick={toggleMenu}
          >
            Shop
          </Link>
          <Link 
            to="/custom" 
            className="text-light hover:text-primary transition-colors py-2 border-b border-gray-800"
            onClick={toggleMenu}
          >
            Custom Orders
          </Link>
          <Link 
            to="/about" 
            className="text-light hover:text-primary transition-colors py-2 border-b border-gray-800"
            onClick={toggleMenu}
          >
            About
          </Link>
          <Link 
            to="/contact" 
            className="text-light hover:text-primary transition-colors py-2"
            onClick={toggleMenu}
          >
            Contact
          </Link>
        </nav>
      </div>
      
      {/* Overlay when menu is open */}
      {menuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        ></div>
      )}
    </header>
  );
};

export default Header;
